import { createFileRoute } from '@tanstack/react-router'
import ProjectsListPage from '@/spa/pages/projects/ProjectsListPage'
import { routeErrorComponent } from '../_shared/RouteError'

export const Route = createFileRoute('/projects/')({
  component: ProjectsListPage,
  errorComponent: routeErrorComponent,
})
